import { FC } from "react";
import { useStyles } from "./styles";
import Dialog from "../Dialog";
import StyledDialogProps from "../Dialog/StyledDialogProps";
import SelectBlock from "./components/SelectBlock";
import { AppRoute } from "../../../router/AppRoute";
import { D_REGISTRATION_DIALOG } from "@/i18n/dictionary/registrationDialog.dictionary";

const RegistrationDialog: FC<StyledDialogProps> = (
  props: StyledDialogProps
) => {
  const { title, subTitle, open, ...rest } = props;
  const classes = useStyles();

  return (
    <Dialog
      title={title || D_REGISTRATION_DIALOG.title}
      subTitle={subTitle || D_REGISTRATION_DIALOG.subTitle}
      open={open}
      {...rest}>
      <SelectBlock
        title={D_REGISTRATION_DIALOG.personalAccountTitle}
        description={D_REGISTRATION_DIALOG.personalAccountDescription}
        route={AppRoute.RECOMMENDATOR_SIGN_UP}
      />
      <SelectBlock
        className={classes.companyBlock}
        title={D_REGISTRATION_DIALOG.companyAccountTitle}
        description={D_REGISTRATION_DIALOG.companyAccountDescription}
        route={AppRoute.COMPANY_REGISTER}
      />
    </Dialog>
  );
};

export default RegistrationDialog;
